<template>
  <div id="view-todo">
    <h1>Todo View</h1>
    <b-form>
      <h3>Category</h3>
      <b-form-input v-model="form.ctg" type="text" disabled></b-form-input><br />
      <h3>Title</h3>
      <b-form-input type="text" v-model="form.title" placeholder="Enter your name" disabled></b-form-input><br/>
      <h3>Content</h3>
      <b-form-textarea id="textarea1"
                          v-model="form.content"
                          placeholder="Enter something"
                          :rows="3"
                          :max-rows="6" disabled>
      </b-form-textarea><br/>
      <h3>DeadLine</h3>
      <b-form-input v-model="form.deadline" type="date" disabled></b-form-input><br />
     </b-form>
     <div class="btns">
         <router-link to="/"><b-button>뒤로가기</b-button></router-link>
         <router-link v-bind:to="{name:'Todoedit', params: {todo_id: this.$route.params.todo_id}}">
           <b-button variant="success">수정하기</b-button>
         </router-link>
     </div>
  </div>
</template>

<script>
import  { dbRef } from '../store/db.js';

export default {
  data(){
    return{
      form:{
        id: null,
        ctg: null,
        title: null,
        content: null,
        deadline: null
      }
    }
  },
  created(){
      dbRef.where('id', '==', this.$route.params.todo_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.form.id = doc.data().id,
          this.form.ctg = doc.data().ctg
          this.form.title = doc.data().title
          this.form.content = doc.data().content
          this.form.deadline = doc.data().deadline
        })
      })
  }
}
</script>

<style scoped>
#view-todo{
  margin-left: 10%;
  margin-right: 10%;
}
h3{
  text-align: left;
  margin-bottom: 1%;
}
.btns{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/TodoView.vue